import type { ReactNode } from 'react'
import classNames from 'classnames'

import './accessibility-skip-link.scss'

type Props = {
  /** Additional content to be rendered inside the component. */
  children: ReactNode
  /** The ID of the navigation element to which the skip link should jump. */
  navigationId: string
  /** The text displayed for the skip link. */
  linkText: string
  /** If true, applies an overflow hidden style to the component. */
  overflowHidden?: boolean
}

/**
 * AccessibilitySkipLink component provides a skip link for improved navigation and accessibility.
 */
export const AccessibilitySkipLink = ({
  navigationId,
  linkText,
  overflowHidden,
  children,
}: Props) => {
  return (
    <div className={classNames('accessibility-skip-link', { 'overflow-hidden': overflowHidden })}>
      <a className="skip-link" href={`#${navigationId}`}>
        {linkText}
      </a>
      {children}
    </div>
  )
}
